module.exports = global["$"] = require("-!/Users/mironpingel/DEV/devtool/12735/113/HoferAntikschmuck/node_modules/expose-loader/index.js?jQuery!./jquery.js");